module.exports = __webpack_public_path__ + "img/8-02.8357ae67.png";